export default "__VITE_ASSET__iftpmgVo__"